<template>
  <v-row
    no-gutters
    align="center"
    class="data-manipulation-wrapper justify-sm-space-between"
  >
    <v-col cols="4" md="6" lg="3" xl="2" v-if="!isMobile">
      <ProductPromoFilter
        v-if="!hidePromoFilter"
        :promoFilter="promoFilter"
        @handlePromoFilter="handlePromoFilter"
        @handleNewFilter="handleNewFilter"
      />
    </v-col>
    <v-col class="pl-md-2" cols="4" md="6" lg="2" xl="1" v-if="!isMobile">
      <ProductCustomFilter
        v-if="!hideCustomFilter"
        :TPFilter="TPFilter"
        @handleTPFilter="handleTPFilter"
    /></v-col>

    <template v-if="facetsFilter">
      <v-col :cols="12" md="6" lg="3" class="pl-md-2">
        <ProductFacetFilterMobile
          v-if="isMobile"
          class="pa-0"
          :facets="facets"
          :facetsFilter="facetsFilter"
          :filteredProductsCount="filteredProductsCount"
          :hideFilterString="hideFilterString"
          :sortFilter="sortFilter"
          :totItems="totItems"
          @handleFacetFilterMobile="handleFacetFilterMobile"
          @handlePromoFilter="handlePromoFilter"
          @handleNewFilter="handleNewFilter"
          @handleTPFilter="handleTPFilter"
          @handleSortFilter="handleSortFilter"
        />

        <ProductFacetFilterDesktop
          v-else
          :facets="facets"
          :facetsFilter="facetsFilter"
          :hideFilterString="hideFilterString"
          @handleFacetFilter="handleFacetFilter"
        />
      </v-col>
    </template>
    <v-spacer></v-spacer>
    <v-col :cols="12" sm="3" class="pl-sm-3 d-none d-md-inline">
      <ProductSortFilter
        v-if="!hideSortFilter"
        :sortFilter="sortFilter"
        @handleSortFilter="handleSortFilter"
      />
    </v-col>
  </v-row>
</template>

<script>
import ProductFacetFilterMobile from "@/components/product/filters/ProductFacetFilterMobile";
import ProductSortFilter from "@/components/product/filters/ProductSortFilter";
import ProductFacetFilterDesktop from "@/components/product/filters/ProductFacetFilterDesktop";
import ProductPromoFilter from "@/components/product/filters/ProductPromoFilter";
import ProductCustomFilter from "@/components/product/filters/ProductCustomFilter";
export default {
  name: "ProductFilters",
  components: {
    ProductFacetFilterMobile,
    ProductFacetFilterDesktop,
    ProductPromoFilter,
    ProductSortFilter,
    ProductCustomFilter
  },
  props: {
    promoFilter: { type: Boolean },
    facets: { type: Array },
    facetsFilter: { type: Object },
    sortFilter: { type: Object },
    filteredProductsCount: { type: Number },
    hidePromoFilter: { type: Boolean, default: false },
    hideFilterString: { type: String, required: false },
    hideCustomFilter: { type: Boolean, default: true },
    hideSortFilter: { type: Boolean, default: false },
    totItems: { type: Number },
    TPFilter: { type: String }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    handleSortFilter(sort) {
      this.$emit("handleSortFilter", sort);
    },
    handlePromoFilter(promo) {
      this.$emit("handlePromoFilter", promo);
    },
    handleNewFilter(onlyNew) {
      this.$emit("handleNewFilter", onlyNew);
    },
    handleTPFilter(onlyTP) {
      this.$emit("handleTPFilter", onlyTP);
    },
    handleFacetFilter(filters) {
      this.$emit("handleFacetFilter", filters);
    },
    handleFacetFilterMobile(selectedFacetsXS) {
      this.$emit("handleFacetFilterMobile", selectedFacetsXS);
    }
  }
};
</script>

<style lang="scss">
.data-manipulation-wrapper {
  @media (max-width: 599px) {
    gap: 20px;
  }
}
</style>
